export default "__VITE_ASSET__Cu$UkDox__"